import { render, staticRenderFns } from "./AgentMessage.vue?vue&type=template&id=8012a60a"
import script from "./AgentMessage.vue?vue&type=script&lang=js"
export * from "./AgentMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports